import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import useParametros from "~fetchs/useParametros";
import { IconDetail, IconCalendar, Loading, Check, Times, Waiting } from "~misc/icons";

const ListagemMapaeVisitas = ({ item, key, selectRoute, visit, visitar, visitaAtiva, type, dias }) => {
  const [unicParametros, setUnicParametros] = React.useState(false);
  const { getBySlug, parametros } = useParametros();
  const colorsStatus = {
    0: "#EE952C",
    1: "#EE952C",
    2: "#727272",
    3: "#727272",
  };

  useEffect(() => {
    getBySlug("status-roteirizacao").then((parametro) => {
      parametro.valor === "nao" ? setUnicParametros(false) : setUnicParametros(true);
    });
  }, [getBySlug, parametros]);

  const handleClick = () => {
    selectRoute(item);
    visitar(item.clienteId, item.dataLabel);
  };

  const statusAtual = useMemo(() => {
    const statusRota = [
      { id: 0, name: "Não visitado", icon: "times", svg: <Times />, style: "bg-[#E6E6E6] text-primaria" },
      { id: 1, name: "Visitado", icon: "check", svg: <Check />, style: "bg-secundaria text-white" },
      { id: 2, name: "Em andamento", icon: "loading", svg: <Loading />, style: "bg-primaria text-white" },
      {
        id: 3,
        name: "Não visitado",
        icon: "times",
        obs: "em andamento com outro cliente",
        svg: <Times />,
        style: "bg-[#E6E6E6] text-primaria",
      },
      { id: 4, name: "Em validação", icon: "waiting", svg: <Waiting />, style: "bg-primaria text-white " },
    ];
    if ((dias || []).includes(item?.visita?.dataLabel) && item.visita?.status == 1)
      return statusRota.find((status) => status.id == 4);

    // Retorna o status padrão "Não visitado" quando não há condição específica
    return statusRota[0];
  }, [item, dias]);

  return (
    <div
      onClick={() => (selectRoute === null ? null : handleClick())}
      key={key}
      data-testid="listagem-container"
      className={`${
        type === "mapa" && (statusAtual?.id === 4 || item?.visitado)
          ? "bg-blue-100 px-8 py-6 mt-6 rounded-lg shadow-lg cursor-pointer hover:border-terciaria border border-solid transition-all"
          : "bg-white px-8 py-6 mt-6 rounded-lg shadow-lg cursor-pointer hover:border-terciaria border border-solid transition-all"
      }`}
    >
      <div className="flex justify-between items-center ">
        <div className="relative">
          {item?.cliente?.bloqueado === true && (
            <div className="flags" data-testid="blocked-flag">
              <div className="card-tag card-tag-bloq">Bloqueado</div>
            </div>
          )}
          <h2 className="text-xl font-bold">{item.codigoCliente + " - " + item.nomeCliente}</h2>
          <p className="mt-1 mb-1 text-[#727272] version3">
            <span className="font-bold">{item.enderecoCliente}</span>
          </p>
          {item?.visita && (
            <p className="mt-1 mb-1 text-[#727272] version3">
              <b>
                Última visita: {item?.visita?.dataLabel} - {item?.visita?.local}
              </b>
            </p>
          )}

          <p className="mt-3 text-[#727272] flex items-center gap-x-1">
            {" "}
            <IconCalendar /> {visit ? "Data da Visita:" : "Visita Planejada:"}{" "}
            <span className="p-[7px] bg-terciaria text-white rounded-md relative ml-2 z-40">
              {item?.dataLabel} {item.local && `  -  ${item.local}`}
              <span className="absolute left-[-4px] top-[11px] z-[-1]">
                <IconDetail />
              </span>
            </span>{" "}
            {item.carteira === false && (
              <span
                data-testid="wallet-warning"
                className="p-[7px] bg-[#FF0000] text-white rounded-md relative ml-2 z-40"
              >
                <span className="">CLIENTE NÃO CONSTA NA CARTEIRA</span>
              </span>
            )}
          </p>
        </div>

        {unicParametros && (
          <div data-testid="status-container">
            {!visit && (
              <div>
                <div className="flex flex-col items-center gap-2 cursor-pointer">
                  {statusAtual?.svg}
                  <label className={`p-2 ${statusAtual?.style} rounded-md `} htmlFor={`todas-${key}`}>
                    {statusAtual?.name}
                  </label>
                </div>
              </div>
            )}
            {visit && (
              <p
                className={`flex gap-x-2 items-center  font-bold self-start`}
                style={{ color: colorsStatus[item?.status] }}
              >
                {item.statusLabel}{" "}
                <span
                  className={`w-4 h-4 block rounded-full	shadow-lg`}
                  style={{ backgroundColor: colorsStatus[item?.status] }}
                ></span>
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

ListagemMapaeVisitas.propTypes = {
  item: PropTypes.shape({
    clienteId: PropTypes.number,
    codigoCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nomeCliente: PropTypes.string,
    enderecoCliente: PropTypes.string,
    dataLabel: PropTypes.string,
    local: PropTypes.string,
    carteira: PropTypes.bool,
    visitado: PropTypes.bool,
    status: PropTypes.number,
    statusLabel: PropTypes.string,
    cliente: PropTypes.shape({
      bloqueado: PropTypes.bool,
    }),
    visita: PropTypes.shape({
      dataLabel: PropTypes.string,
      local: PropTypes.string,
      status: PropTypes.number,
    }),
  }),
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectRoute: PropTypes.func,
  visit: PropTypes.bool,
  visitar: PropTypes.func,
  visitaAtiva: PropTypes.any,
  type: PropTypes.string,
  dias: PropTypes.array,
};

export default ListagemMapaeVisitas;
